/**
 * Suppresses the browser's automatic PWA install UI (Chrome's mobile mini-infobar
 * and desktop omnibox icon) by calling `preventDefault()` on `beforeinstallprompt`
 * without ever calling the deferred prompt's `.prompt()` - so no install affordance
 * is shown anywhere. iOS Safari never fires this event (Add to Home Screen is a
 * manual Share-sheet action), so it is unaffected either way.
 */
export function suppressInstallPrompt(): void {
  window.addEventListener('beforeinstallprompt', (e) => e.preventDefault());
}
